import { FC } from 'react';
import { RiFileExcel2Line } from 'react-icons/ri';

interface IProps {
  onClick: () => void;
}

const DownloadButton: FC<IProps> = ({ onClick }) => {
  return (
    <div className='comm-btn__area'>
      <button
        className="btn-basic green"
        onClick={onClick}
      >
        <span style={{ display: 'inline-block', transform: 'translateY(-1px)'  }}><RiFileExcel2Line /></span>
        <span className="ml-1">DOWNLOAD</span>
      </button>
    </div>
  )
}

export default DownloadButton;
